import React, { ReactElement } from 'react';

import { Typography, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getFormattedDateForTooltip } from '../utils';

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    border: '1px solid #EA0BBD',
    borderRadius: '12px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    padding: '16px 12px',
  },
});

const MasteryLabel = styled(Typography)`
  color: #0f1629;
  font-size: 24px;
  text-align: center;
`;

const DateLabel = styled(MasteryLabel)`
  font-size: 16px;
`;

type Props = {
  mastered: number | null | undefined;
  date: string;
  children: ReactElement<any, any>;
};

export const MasteryHeatMapTooltip = ({ mastered, date, children }: Props) => (
  <HtmlTooltip
    disableInteractive
    placement="top"
    title={
      <React.Fragment>
        <MasteryLabel color="inherit">{mastered}</MasteryLabel>
        <DateLabel color="inherit">{getFormattedDateForTooltip(date)}</DateLabel>
      </React.Fragment>
    }
  >
    {children}
  </HtmlTooltip>
);
